import { Component, ViewChild } from '@angular/core';
import { Timeshift } from './model/timeshift';
import { ProjecttimeshiftService } from './service/projecttimeshift.service';


import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projectimeshift',
  templateUrl: './projectimeshift.component.html',
  styleUrls: ['./projectimeshift.component.css']
})
export class ProjectimeshiftComponent {
  timeShift: Timeshift = new Timeshift;
  showSpinner: boolean = false;
  @ViewChild('closetimeshift',{static:true}) closetimeshift;
  consoleError: string = 'Invalid input, please use only numbers, examples 2 or -2';
  consoleErrorToggle: boolean = false;

  constructor(private tmsrv: ProjecttimeshiftService) {

}

  shiftTime() {
    this.showSpinner = true;
    //console.log('timeShift', this.timeShift);

    var regex = /^-?\d+$/;
  if (regex.test(this.timeShift.duration.toString().trim())){
    this.tmsrv.timeshiftTask(this.timeShift).pipe(untilDestroyed(this)).subscribe(res => { 
      //console.log(res) 
    });
    setTimeout(()=>{
      this.showSpinner = false;
      this.closetimeshift.nativeElement.click();
      //refresh page
      window.location.reload();
     
    },5000);
  } else {
    this.showSpinner = false;
    console.error('Invalid input');
    this.consoleErrorToggle = true;
  }

  }

}
